export default "__VITE_ASSET__CZjXUaRA__"